import type { ReactNode } from 'react';
import { PackagingSheet } from './PackagingSheet';
import { fetchPackagingByJobIds } from './packagingData';

/** `@page` for the delivery-job printout; moves with CARDS_PER_SHEET (see PackagingSheet). */
export const PACKAGING_PRINT_PAGE = { size: 'letter portrait', margin: '15mm 4mm 14mm' } as const;

/**
 * The one delivery-job print builder, shared by the job list and the dispatch
 * detail pane. It re-reads by job id at print time, so the paper shows the
 * data as of the click.
 */
export async function buildPackagingSheet(
  jobIds: readonly string[],
  pageBreakPerDriver: boolean,
): Promise<ReactNode> {
  const result = await fetchPackagingByJobIds(jobIds);
  return <PackagingSheet result={result} pageBreakPerDriver={pageBreakPerDriver} />;
}
